import React, { useState } from 'react';
import './Requests.css';

const Requests = ({
  requests,
  requestsLoading,
  teams,
  approvalTeams,
  onSelectTeam,
  onApprove,
  onDeny,
  statusMsg,
  onReload,
}) => {
  const [openRows, setOpenRows] = useState({});

  const toggleRow = (id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="sa-card">
      <div className="sa-card-header">
        <h2>Team Join Requests</h2>
        <div className="sa-actions">
          <button className="sa-btn ghost" onClick={onReload} disabled={requestsLoading}>
            {requestsLoading ? 'Loading...' : 'Reload'}
          </button>
        </div>
      </div>
      {statusMsg && <div className="sa-status">{statusMsg}</div>}

      <div className="requests-table">
        <div className="requests-head">
          <span>User</span>
          <span></span>
        </div>

        {requests.map((r) => {
          const status = r.status || 'pending';
          const code = r.code || '';
          const isOpen = !!openRows[r.id];
          return (
            <div className="requests-row" key={r.id}>
              <div className="req-row-top">
                <span className="req-team-cell">
                  <button className="sa-link" onClick={() => toggleRow(r.id)}>
                    {isOpen ? '▼' : '▶'}
                  </button>
                  {r.email || r.userId || '-'}
                </span>
                <span className="req-actions-inline">
                  <span className={`req-status-pill ${status}`}>{status}</span>
                  <button className="sa-link" onClick={() => toggleRow(r.id)}>
                    {isOpen ? 'Hide' : 'Manage'}
                  </button>
                </span>
              </div>

              {isOpen && (
                <div className="req-expanded">
                <div className="req-details-head">
                  <span>Requested Team</span>
                  <span>Status</span>
                  <span>Team Assign</span>
                  <span>Actions</span>
                  <span>Code</span>
                </div>
                <div className="req-details-row">
                  <span className="req-primary">{r.requestedTeamName || r.requestedTeamId || '-'}</span>
                  <span>
                    <span className={`req-status-pill ${status}`}>{status}</span>
                  </span>
                  <span>
                    <select
                      className="sa-select"
                      value={approvalTeams[r.id] || ''}
                      onChange={(e) => onSelectTeam(r.id, e.target.value)}
                    >
                        <option value="">Select team</option>
                        {teams.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.name || t.teamName || t.id}
                          </option>
                        ))}
                      </select>
                  </span>
                  <span className="req-actions">
                      <button className="sa-link" onClick={() => onApprove(r)}>
                        Approve + code
                      </button>
                      <button className="sa-link danger" onClick={() => onDeny(r.id)}>
                        Deny
                      </button>
                  </span>
                  <span className="req-code-cell">
                    {code ? (
                      <button
                        className="sa-link"
                        onClick={() => {
                          if (navigator?.clipboard) navigator.clipboard.writeText(code);
                        }}
                      >
                        {code} (copy)
                      </button>
                    ) : (
                      <span className="req-secondary">—</span>
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>
          );
        })}

        {requests.length === 0 && <div className="sa-empty">No requests found.</div>}
      </div>
    </div>
  );
};

export default Requests;
